import React, { Component } from 'react'

import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Button, Panel, Grid, Col, Row, Label } from 'react-bootstrap'

class PostCard extends Component {

  handleDocumentClick = (documentUrl) => {
    let win = window.open(documentUrl, '_blank');
    win.focus()
  }

  render () {
    let createdBy = `${this.props.post.created_by.first_name} ${this.props.post.created_by.last_name}`
    let createdById = this.props.post.created_by.id

    let postedDate = this.props.post.created_date.split("T")[0].split("-")
    let formatedDate = `${postedDate[1]}-${postedDate[2]}-${postedDate[0]}`

    return (
      <Col xs={12} md={12}>
        <div id="PostCard">
          <Panel>
            <Panel.Heading className="post-card-heading">
            </Panel.Heading>
            <Panel.Body className="post-card-body">
              <Grid>
                <Link to={`/resource-posts/${this.props.post.id}`}>
                  <Row className="clickable-row">
                    <Col xs={12} md={8}>
                      <h3 className="post-description">
                        {this.props.post.name}
                      </h3><br/>
                    </Col>
                    <Col xs={12} md={4}>
                      <div>
                        <div>Posted on: {formatedDate}</div>
                        <div>
                          Posted by: <span
                          className={createdById === this.props.currentUser.pk ? "current-user" : null}
                          >
                          {createdBy}
                        </span>
                        </div>
                      <div>Views: {this.props.post.views}</div>
                      </div>
                    </Col>
                  </Row>
                </Link>
                <Row>
                  {this.props.post.document ?
                  <div className="document-button">
                    <Button
                      onClick={() => this.handleDocumentClick(this.props.post.document)}
                    >
                      Attached document
                    </Button>
                  </div>
                  :
                  null
                  }
                </Row>
                <Row>
                  <div>
                    {this.props.post.tags.map(tag => {
                      return (
                        <span key={tag.id} className="tag">
                          <Label bsStyle="default">
                            #{tag.name}
                          </Label>
                          &nbsp;&nbsp;
                        </span>
                      )
                    })}
                  </div>
                </Row>
              </Grid>
            </Panel.Body>
          </Panel>
        </div>
      </Col>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.manageLogin.user
  }
}

export default connect(mapStateToProps)(PostCard);



// WEBPACK FOOTER //
// ./src/routes/resource-posts/components/PostCard.js